import { useState } from 'react';
import { PencilIcon, TrashIcon, CheckIcon, XIcon } from '@heroicons/react/solid';

export default function EditableTableToggle({data, fields, toggleOff, toggleOn, onUpdate, onDelete}) {
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});

  const startEdit = (row) => {
    setEditingId(row[0]);
    setEditValues({
      naam: row[1],
      etiket: row[2] || ''
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditValues({});
  };

  const saveEdit = async(id) => {
    await onUpdate(id, editValues.naam, editValues.etiket);
    setEditingId(null);
    setEditValues({});
  };

  const handleDelete = (id) => {
    if (window.confirm("Weet je zeker dat je dit product wilt verwijderen?")) {
      onDelete(id);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {fields.map((field, fieldIdx) => (
                    <th
                      key={fieldIdx}
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {field}
                    </th>
                  ))}
                  {toggleOff && (
                    <th
                      scope="col"
                      className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      weergeven in lijst
                    </th>
                  )}
                  <th
                    scope="col"
                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    ACTIES
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIdx) => (
                  <tr key={row[0]} className={rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    {/* Naam field */}
                    <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-normal break-words">
                      {editingId === row[0] ? (
                        <input
                          type="text"
                          value={editValues.naam}
                          onChange={(e) => setEditValues({...editValues, naam: e.target.value})}
                          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        />
                      ) : (
                        row[1]
                      )}
                    </td>

                    {/* Etiket field (if exists) */}
                    {typeof row[2] !== 'undefined' && (
                      <td className="px-6 py-4 text-sm text-gray-500 whitespace-normal break-words">
                        {editingId === row[0] ? (
                          <input
                            type="text"
                            value={editValues.etiket}
                            onChange={(e) => setEditValues({...editValues, etiket: e.target.value})}
                            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          />
                        ) : (
                          row[2]
                        )}
                      </td>
                    )}

                    {/* Display toggle */}
                    {toggleOff && (
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        {row[3] == "1" ? (
                          <input
                            id={`toggle-${row[0]}`}
                            type="checkbox"
                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            onClick={() => toggleOff(row[0])}
                            checked
                            readOnly
                          />
                        ) : (
                          <input
                            id={`toggle-${row[0]}`}
                            type="checkbox"
                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            onClick={() => toggleOn(row[0])}
                            readOnly
                          />
                        )}
                      </td>
                    )}

                    {/* Action buttons */}
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex justify-end gap-2">
                        {editingId === row[0] ? (
                          <>
                            <button
                              onClick={() => saveEdit(row[0])}
                              className="text-green-600 hover:text-green-900 transition-colors"
                              title="Opslaan"
                            >
                              <CheckIcon className="h-5 w-5" />
                            </button>
                            <button
                              onClick={cancelEdit}
                              className="text-gray-400 hover:text-gray-600 transition-colors"
                              title="Annuleren"
                            >
                              <XIcon className="h-5 w-5" />
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => startEdit(row)}
                              className="text-indigo-600 hover:text-indigo-900 transition-colors"
                              title="Bewerken"
                            >
                              <PencilIcon className="h-5 w-5" />
                            </button>
                            <button
                              onClick={() => handleDelete(row[0])}
                              className="text-red-600 hover:text-red-900 transition-colors"
                              title="Verwijderen"
                            >
                              <TrashIcon className="h-5 w-5" />
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
